function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var DietOfWormsTemplate = require('./diet-of-worms.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DietOfWormsOverlay = /*#__PURE__*/function () {
  function DietOfWormsOverlay(app, mod) {
    _classCallCheck(this, DietOfWormsOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(DietOfWormsOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.pushHudUnderOverlay();
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      this.visible = true;
      this.overlay.show(DietOfWormsTemplate(this.mod, this.mod.game.players.length));
      this.pullHudOverOverlay();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }, {
    key: "addCardToCardfan",
    value: function addCardToCardfan(card) {
      var fan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'protestant';
      if (!document.querySelector('.diet-overlay')) {
        return;
      }
      var html = "<div id=\"".concat(card, "\" class=\"card hud-card ").concat(card, "\">").concat(this.mod.returnCardImage(card, 0), "</div>");
      if (fan === 'protestant') {
        this.app.browser.addElementToSelector(html, '.cardfans .protestant');
      } else {
        this.app.browser.addElementToSelector(html, '.cardfans .catholic');
      }

      //
      // add cardfan effect if 2 cards
      //
      if (document.querySelector('.cardfans .catholic').querySelectorAll('div').length > 1) {
        document.querySelector('.catholic>.card:nth-child(1)').style.transform = 'rotate(-10deg)';
        document.querySelector('.catholic>.card:nth-child(1)').style.zIndex = 30;
      }
    }
  }, {
    key: "showResults",
    value: function showResults(obj) {
      var _this = this;
      var his_self = this.mod;
      this.mod.hud.updateStatus('');
      if (!document.querySelector('.diet-overlay')) {
        return;
      }
      var protestant_hits = obj.protestant_hits;
      var papacy_hits = obj.papacy_hits;
      var protestant_rolls = obj.protestant_rolls;
      var papacy_rolls = obj.papacy_rolls;
      var winner = obj.winner;
      var difference = obj.difference;
      var html = '';
      html = 'Protestants: [';
      for (var i = 0; i < protestant_rolls.length; i++) {
        if (i > 0) {
          html += ', ';
        }
        html += protestant_rolls[i];
      }
      html += '] ' + protestant_hits + ' ';
      if (protestant_hits == 1) {
        html += 'hit';
      } else {
        html += 'hits';
      }
      html += '<p></p>';
      html += 'Catholics: [';
      for (var _i = 0; _i < papacy_rolls.length; _i++) {
        if (_i > 0) {
          html += ', ';
        }
        html += papacy_rolls[_i];
      }
      html += '] ' + papacy_hits + ' ';
      if (papacy_hits == 1) {
        html += 'hit';
      } else {
        html += 'hits';
      }
      html += '<p></p>';
      var hits = 'hits';
      if (difference == 1) {
        hits = 'hit';
      }
      var spaces = 'spaces';
      if (difference == 1) {
        spaces = 'space';
      }
      if (winner === 'protestant') {
        html += 'Protestants may convert ' + difference + ' ' + spaces + ' (<span class="diet_of_worms_end"> click here </span>)';
      } else {
        if (winner === 'papacy') {
          html += 'Papacy may convert ' + difference + ' ' + spaces + ' (<span class="diet_of_worms_end"> click here </span>)';
        } else {
          html += 'Diet of Worms ends inconclusively (<span class="diet_of_worms_noskip"> click here </span>)';
        }
      }
      document.querySelector('.diet-overlay .help').innerHTML = html;
      $('.diet_of_worms_noskip').off();
      $('.diet_of_worms_noskip').on('click', function () {
        _this.hide();
      });
      $('.diet_of_worms_end').off();
      $('.diet_of_worms_end').on('click', function () {
        var lqe = his_self.game.queue[his_self.game.queue.length - 1];
        var mv = lqe.split('\t');
        if (mv[0] === 'ACKNOWLEDGE') {
          var _obj = document.querySelector('.option.acknowledge');
          if (_obj) {
            _obj.click();
          } else {
            his_self.game.queue.splice(his_self.game.queue.length - 1, 1);
            his_self.restartQueue();
          }
        }
        _this.overlay.remove();
      });
    }
  }]);
}();
module.exports = DietOfWormsOverlay;